export default {
    props: {
        requestCompletions: {
            type: Object,
            required: false,
            default: () => null,
        },
    },
    computed: {
        completionsResponse() {
            return this.requestCompletions ? this.requestCompletions.response : null;
        },
        completionsItems() {
            if (this.completionsResponse) {
                return this.completionsResponse.map(el => Object.assign({ 'active': 0 }, el));
            }
            return [];
        },
        showCompletions() {
            return this.store.state.ui.isCompletionsVisible &&
                (Boolean(this.completionsItems.length) || this.$configuration.skuStrict && this.isSku) && this.isFocused;
        },
        isCompletionsLoading() {
            return this.requestCompletions ? this.requestCompletions.isLoading : false;
        },
        isCompletionsError() {
            return this.requestCompletions ? this.requestCompletions.isError : false;
        },
        errorTextCompletions() {
            return this.requestCompletions ? this.requestCompletions.errorText : null;
        },
    },
};
